import { gsap, ScrollToPlugin } from "@gsap";

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollToPlugin);

	const anchorLinks = document.querySelectorAll("a[href^='#']");
	anchorLinks.forEach(anchorLink => {
		const target = anchorLink.getAttribute("href");
		if(target.length <= 1) return;
		const targetLayout = document.querySelector(target);
		if(targetLayout) {
			anchorLink.addEventListener("click", (e) => {
				e.preventDefault();
				gsap.to(window, {
					scrollTo: {
						y: targetLayout,
						offsetY: document.querySelector("header").offsetHeight * 2
					}
				})
			});
		}
	});
});